import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-failure-payment',
  templateUrl: './failure-payment.component.html',
  styleUrl: './failure-payment.component.css'
})
export class FailurePaymentComponent implements OnInit {
  errorMessage: string | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.errorMessage = this.route.snapshot.queryParamMap.get('error') ||
      this.route.snapshot.queryParamMap.get('message') ||
      null;
  }
}
